import * as React from 'react'
// icons
import AddIcon from '@mui/icons-material/Add'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
// hooks
import { useShowModal } from 'hooks/useShowModal'
import { useConversations } from '../../ConversationsContext'
// views
import {
  DeleteButton,
  SidebarInner,
  SidebarTopRow,
  NewChatButton,
  CollapseButton,
  IconOnlyButton,
  CollapsedColumn,
  ConversationItem,
  SidebarContainer,
  NewChatIconButton,
  ConversationsList,
  ConversationTitle,
  ConversationsLabel
} from './views'
// types
import { Modals } from 'constants/modals'
// utils
import { stripMarkdown } from '../Markdown/utils'

type Props = {
  isOpen: boolean
  onToggle: () => void
  onNewChat: () => void
  onSelect: (id: string) => void
}

const Sidebar: React.FC<Props> = ({ isOpen, onToggle, onNewChat, onSelect }) => {
  const { showModal } = useShowModal({ modalType: Modals.CONFIRM_DELETE_CHAT_CONVERSATION_MODAL })

  const { conversations, currentConversationId, deleteConversation } = useConversations()

  const handleDelete = (e: React.MouseEvent, id: string) => {
    e.stopPropagation()

    showModal({
      width: 'sm',
      handleConfirm: async () => deleteConversation(id)
    })
  }

  return (
    <SidebarContainer $isOpen={isOpen}>
      <SidebarInner>
        {isOpen ? (
          <>
            <SidebarTopRow>
              <NewChatButton onClick={onNewChat}>
                <AddIcon fontSize='small' />
                New Chat
              </NewChatButton>
              <CollapseButton onClick={onToggle}>
                <ChevronLeftIcon fontSize='small' />
              </CollapseButton>
            </SidebarTopRow>

            <ConversationsLabel>Conversations</ConversationsLabel>

            <ConversationsList>
              {conversations.map((conv) => (
                <ConversationItem
                  key={conv.id}
                  $isActive={conv.id === currentConversationId}
                  onClick={() => onSelect(conv.id)}>
                  <ChatBubbleOutlineIcon sx={{ fontSize: 14, flexShrink: 0 }} />
                  <ConversationTitle>{conv.title ? stripMarkdown(conv.title) : 'New Chat'}</ConversationTitle>
                  <DeleteButton onClick={(e) => handleDelete(e, conv.id)}>
                    <DeleteOutlineIcon sx={{ fontSize: 16 }} />
                  </DeleteButton>
                </ConversationItem>
              ))}
            </ConversationsList>
          </>
        ) : (
          <CollapsedColumn>
            <IconOnlyButton onClick={onToggle}>
              <ChevronRightIcon fontSize='small' />
            </IconOnlyButton>
            <NewChatIconButton onClick={onNewChat}>
              <AddIcon fontSize='small' />
            </NewChatIconButton>
          </CollapsedColumn>
        )}
      </SidebarInner>
    </SidebarContainer>
  )
}

export default Sidebar
